import React from "react";
import Button from "react-bootstrap/esm/Button";
import Modal from "react-bootstrap/esm/Modal";
import {getCookie} from "../common/utils";

const LogoutModal = ({title, message, yesActionLabel, yesAction, noActionLabel, noAction}) => {
    const auth_email = getCookie('auth_email');
    return (
        <Modal
            show={true}
            size="lg"
            centered
            onHide={() => noAction ? noAction() : null}
            className='login-modal rbg-popup-generic login-modal__logout'
            container={document.getElementById('react-header')}
            backdropClassName="dark-overlay login-modal__dark-overlay"
        >
            <Modal.Header className="rbg-popup-generic__header">
                {noAction &&
                    <Button
                        className="rbg-popup-generic__close-icon"
                        onClick={noAction}
                        variant="clean"
                    >
                        <span className="icon-close" />
                    </Button>
                }
                <div id="fb-root"/>
            </Modal.Header>
            <Modal.Body className="rbg-popup-generic__body">
                <p className={`login-modal__logout-title ${message === 'BAD_DOMAIN' && 'login-modal__logout-title--bad-domain'}`}>{title}</p>
                <div className="login-modal__title-subline"/>
                {message === 'BAD_DOMAIN' &&
                    <div className="login-modal__logout--bad-domain">
                        <div>
                            Unfortunately, the domain of {auth_email} the email that you've used
                            to sign-up with Rebag is no longer supported for transactions.
                        </div>
                        <div className="login-modal__logout--bad-domain--example">E.g. johnsmith@example.com -> domain is example.com</div>
                        <div>
                            Please create a new account with a valid email domain in order to purchase on Rebag.
                            If you would like to transfer your old account history to your new one -
                            please <a href="https://support.rebag.com/hc/en-us/articles/360038451531-How-do-I-contact-Rebag">contact us here</a>
                        </div>
                    </div>
                }
                {message !== 'BAD_DOMAIN' &&
                    <h2 className="login-modal__logout-intro-text">{message}</h2>
                }

                {yesActionLabel &&
                    <Button
                        className={`rbg-btn-black login-modal__submit login-modal__submit-logout ${message === 'BAD_DOMAIN' && 'login-modal__submit-logout--bad-domain'}`}
                        variant="secondary"
                        onClick={yesAction}
                    >
                        {yesActionLabel}
                    </Button>
                }
                {noActionLabel &&
                    <Button
                        className="rbg-btn-ghost login-modal__submit login-modal__submit-logout login-modal__submit-logout--no"
                        variant="secondary"
                        onClick={noAction}
                    >
                        {noActionLabel}
                    </Button>
                }
            </Modal.Body>
        </Modal>
    )
}

export default LogoutModal;